'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PolicyViewScreen } from '../-components/PolicyViewScreen';
export const Route = createFileRoute('/_staff/settings/notification-and-response/notification-policies/$policyId/')({
  component: NotificationPolicyDetail
});
function NotificationPolicyDetail() {
  const {
    policyId
  } = Route.useParams();
  return <PolicyViewScreen policyId={policyId} />;
}